import { render, staticRenderFns } from "./sold_items.vue?vue&type=template&id=d7cb03b8"
import script from "./sold_items.vue?vue&type=script&lang=js"
export * from "./sold_items.vue?vue&type=script&lang=js"
import style0 from "./sold_items.vue?vue&type=style&index=0&id=d7cb03b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports